/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for updating an MCP endpoint. This is a full-record replace: the custom_domain_id field omitted from the request becomes null on the stored record. Provide exactly one of mcp_server_id or meta_mcp_server_id. Platform-domain endpoint slugs (no custom_domain_id) must be prefixed with the organization slug.
 */
export type UpdateMcpEndpointForm = {
  /**
   * The ID of the custom domain to register the endpoint slug under. Omit to move the endpoint to a platform domain.
   */
  customDomainId?: string | undefined;
  /**
   * The ID of the MCP endpoint to update
   */
  id: string;
  /**
   * The ID of the MCP server this endpoint addresses. Mutually exclusive with meta_mcp_server_id.
   */
  mcpServerId?: string | undefined;
  /**
   * The ID of the meta MCP server this endpoint addresses. Mutually exclusive with mcp_server_id.
   */
  metaMcpServerId?: string | undefined;
  /**
   * A url-friendly label (up to 128 characters) that addresses an MCP server through a slug-based URL. Platform-domain slugs (no custom domain) must be prefixed with the organization slug.
   */
  slug: string;
};

/** @internal */
export type UpdateMcpEndpointForm$Outbound = {
  custom_domain_id?: string | undefined;
  id: string;
  mcp_server_id?: string | undefined;
  meta_mcp_server_id?: string | undefined;
  slug: string;
};

/** @internal */
export const UpdateMcpEndpointForm$outboundSchema: z.ZodMiniType<
  UpdateMcpEndpointForm$Outbound,
  UpdateMcpEndpointForm
> = z.pipe(
  z.object({
    customDomainId: z.optional(z.string()),
    id: z.string(),
    mcpServerId: z.optional(z.string()),
    metaMcpServerId: z.optional(z.string()),
    slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      customDomainId: "custom_domain_id",
      mcpServerId: "mcp_server_id",
      metaMcpServerId: "meta_mcp_server_id",
    });
  }),
);

export function updateMcpEndpointFormToJSON(
  updateMcpEndpointForm: UpdateMcpEndpointForm,
): string {
  return JSON.stringify(
    UpdateMcpEndpointForm$outboundSchema.parse(updateMcpEndpointForm),
  );
}
